<div class="card">
  <div class="card-content">
    <div class="page-header">
      <h4>{{ 'UPDATE_COMMERCIAL_LICENSE_MAPPING' | translate }}</h4>
    </div>

    <form autocomplete="off" class="form" (submit)="onSubmit($event)">
      <div class="field is-narrow">
        <label
          class="label"
          translationEditableDirective="translationEditableDirective="
          >{{ 'PROPERTY_TYPE' | translate }}</label
        >
        <div class="control">
          <input
            class="input"
            name="propertyType"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['propertyType'])"
            [ngClass]="{ 'is-danger': hasError('propertyType') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('propertyType')">
          {{ getError('propertyType') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="RATE">{{
          'RATE' | translate
        }}</label>
        <div class="control">
          <number-input
            name="rate"
            (input)="handleFieldChange($event)"
            [value]="getField(['rate'])"
            [inputClass]="{ input: true, 'is-danger': hasError('rate') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('rate')">
          {{ getError('rate') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="TEMPLATE">{{
          'TEMPLATE' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="templates"
            [multiple]="false"
            [closeOnSelect]="true"
            (change)="handleFieldChange($event?.id, 'templateId')"
            [ngClass]="{ 'is-danger': hasError('templateId') }"
            bindLabel="name"
            bindValue="id"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="getField(['templateId'])"
          >
          </ng-select>
        </div>
        <p class="help is-danger" *ngIf="hasError('templateId')">
          {{ getError('templateId') }}
        </p>
      </div>

      <div class="field is-narrow" *ngIf="getField(['fileName'])">
        <div class="control">
          <a
            target="_blank"
            class="button is-secondary is-flex"
            [href]="getDownloadLink(getField(['id']))"
          >
            <img
              width="22"
              style="margin-right: 10px"
              src="/assets/docx.svg"
              alt=""
            />
            {{ getField(['fileName']) }}
          </a>
        </div>
      </div>

      <div class="field is-grouped">
        <div class="control">
          <button
            [disabled]="isLoading"
            type="submit"
            class="button is-link"
            translationEditableDirective="SUBMIT"
          >
            {{ 'SUBMIT' | translate }}
          </button>
        </div>
        <div class="control">
          <a
            [routerLink]="['/admin/commercial-license-mappings']"
            class="button is-link is-light"
            translationEditableDirective="CANCEL"
            >{{ 'CANCEL' | translate }}</a
          >
        </div>
      </div>
    </form>
  </div>
</div>
